import React from 'react';
import { type } from 'ramda';
/** cSpell:ignore Unmount */
/* eslint-disable react-hooks/exhaustive-deps */
const useWillUnmount = (fn) => {
  React.useEffect(() => {
    if (type(fn) !== 'Function') {
      throw SyntaxError(`useWillUnmount expect a function, but got a ${type(fn)}`);
    }
    return () => {
      fn();
    };
  }, []);
};

export default useWillUnmount;
